import CheckQuery from './component'

export default {
  install:  (Vue) => {
    let iCheckQuery = Vue.extend(CheckQuery)
    Vue.prototype.$checkQuery = {
      show: (data) => {
        let instance = new iCheckQuery ({
          el: document.createElement('div'),
        })
        document.body.appendChild(instance.$el)
        instance.show(data)
      }
    }
  }
}
